import { render, staticRenderFns } from "./SplitPaymentTypesForm.vue?vue&type=template&id=6519e0d9&scoped=true&"
import script from "./SplitPaymentTypesForm.vue?vue&type=script&lang=js&"
export * from "./SplitPaymentTypesForm.vue?vue&type=script&lang=js&"
import style0 from "./SplitPaymentTypesForm.vue?vue&type=style&index=0&id=6519e0d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6519e0d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
